module.exports = __webpack_public_path__ + "img/9788970907697.9a6f0595.jpg";